import { Extension } from '@tiptap/vue-3';

declare module '@tiptap/vue-3' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Commands<ReturnType> {
    utilCommands: {
      /**
       * add a new line below the current one (Shift-Enter in regular editors)
       */
      insertLineBelow: () => ReturnType;
      focusNearestPositionForBlockElement: () => ReturnType;
      setContentWithPasteRules: (content: string) => ReturnType;

      /**
       * it seems like `focus('end', { scrollIntoView: false })` is not working as it should so we need a custom command */
      focusWithoutScrolling: () => ReturnType;
    };
  }
}

// tiptap extensions have this naming convention
// eslint-disable-next-line @typescript-eslint/naming-convention
export const UtilCommands = Extension.create({
  name: 'utilCommands',

  addCommands() {
    return {
      insertLineBelow:
        () =>
        ({ editor, chain }) => {
          const nodePos = editor.view.state.selection.to;

          const c = chain().focus(nodePos).insertContent('<p></p>');

          // select newline if there is no other selection
          if (!editor.state.selection.empty) {
            c.selectNodeBackward();
          }
          return c.run();
        },
      focusNearestPositionForBlockElement:
        () =>
        ({ editor, commands }) => {
          if (editor.state.selection.empty) {
            return commands.focus();
          }

          const selectionEnd = editor.state.selection.to;
          return commands.focus(selectionEnd);
        },
      focusWithoutScrolling:
        () =>
        ({ view }) => {
          view.focus();
          return true;
        },
    };
  },
});
